/*
 * Ported verbatim from the legacy app's scripts/app/components/facebook.js.
 * Relies on the global `jQuery` shim set up in main.js and the Facebook SDK's
 * `FB` global (loaded separately via the SDK `<script>` tag in Master.cshtml).
 */
(function ($) {

    
    $.changeFBPagePlugin = function () {
        //getting parent box width
        var fbw = $('.fb-column').width();
        if ($('.fb-column').is(':visible')) {
            var containerWidth = (Number($('.fb-column').width()) - Number($('.fb-column').css('padding-left').replace('px', ''))).toFixed(0);
            //getting parent box height
            var containerHeight = (Number($('.fb-column').height())).toFixed(0);
            if (!isNaN(containerWidth) && !isNaN(containerHeight)) {
                $('.fb1').attr('data-width', containerWidth).attr('data-height', containerHeight);
            }
            if (typeof FB !== 'undefined') {
                window.FB.XFBML.parse();
            }
        }
    };

    $.resizeFB = function () {
        console.log('ResizeStuff');  
        if ($('.fb-column').is(':visible')) {
            $.changeFBPagePlugin();
        }
    };
    var TO = false;
    $(window).resize(function () {
        if (TO !== false) {
            clearTimeout(TO);
        }
        TO = setTimeout($.resizeFB, 300); 
    });


    $(window).on('load', function () {

        var finishedRendering = function () {
            console.log('finished rendering plugins');
        };

        window.FB.Event.subscribe('xfbml.render', finishedRendering);

    setTimeout(function () {
        console.log('onLoad');
        if ($('.fb-column').is(':visible')) {
            $.changeFBPagePlugin();
        }
    }, 1000);
});

})(window.jQuery);
